module.exports = "<span class=\"container\">\n    <span (click)=\"toggle()\" class=\"toggle-button\" [ngClass]=\"{'glow': glow}\">[?]</span>\n    <div *ngIf=\"showHelpModal\" class=\"modal\" [ngClass]=\"{'pop-left': popLeft, 'fade-slide': !popLeft, 'fade-slide-pop-left': popLeft}\">\n        <span class=\"close\" (click)=\"close()\">&times;</span>\n        <ng-content select=\".title\"></ng-content>\n        <ng-content select=\".body\"></ng-content>\n    </div>\n</span>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/help-modal/help-modal.component.html
// module id = ./src/app/help-modal/help-modal.component.html
// module chunks = main